<template>
	<div class="schemelist">
		<el-card>
			<div v-for="tab in tabs">
				<el-row>
					<el-col :span="17">
						<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
						<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
					</el-col>
					<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
					<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
				</el-row>
				<el-row style="height:10px;"></el-row>
				<el-row>
					<el-col :span="24">
						<tableui
							style="width:100%;"
							v-loading="loading"
							ref="trashlistable"
							:tableData="schemelist"
							:columns="tab.columns"
							@gridhandle="gridhandle"
							:gridheight="gridheight"
						></tableui>
					</el-col>
				</el-row>
			</div>
			<div>
				<el-row>
					<el-col :span="12">
						<span>共 {{ count }} 条数据</span>
					</el-col>
				</el-row>
			</div>
		</el-card>
		<selectcargocno ref="selectcargocno"></selectcargocno>
	</div>
</template>

<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import selectcargocno from '@/components/baseinfo/selectcargocno.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton,
		selectcargocno
	},
	data() {
		return {
			searchbox: '',
			count: 0,
			gridheight: (window.innerHeight * 74) / 100 + 'px',
			loading: false,
			schemename: '',
			mode: '商品税率',
			schemelist: [],
			tabs: [],
			activeName: '',
			activetab: '',
			activeTabIndex:0,
			divclass:'schemelist'
		};
	},
	mounted() {
		var that = this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid(true);
		});
		this.getTabs();
	},
	methods: {
		getTabs() {
			var that = this;
			this.$apipost.get.GetTabs({ parentid: 328 }).then(res => {
				if (res.tabs != undefined) {
					that.tabs = res.tabs;
					let tab = this.tabs[0];
					that.activeName = tab.type;
					that.activetab = tab.name;
					that.GetTabData();
				} else {
					that.getTabs();
				}
			});
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
			}
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode, sys: '商城系统' }).then(res => {
				//console.log('列配置',JSON.stringify(res));
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				this.schemelist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall = false;
			}
			if (isload) {
				this.loading = true;
				var paraminfo = {
					mode: this.mode,
					tab: this.tabs[this.activeTabIndex].type,
					search: this.GetSearchObj(),
					pageindex: this.pageindex,
					pagesize: this.pagesize,
					sort: this.sort,
					iscount: 1,
					showcol: JSON.stringify(that.tabs[that.activeTabIndex].columns),
					sys: '商城系统'
				};
				this.$apipost.get.GetGridTable({ paraminfo: paraminfo }).then(res => {
					that.loading = false;
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.schemelist.push(res.data);
						} else {
							that.schemelist = res.data;
						}
					} else {
						that.schemelist = [];
					}
					this.count = res.count;
				});
			}
		},
		GetSearchObj() {
			var search = {};
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'add') {
				this.addtaxscheme(e);
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			if (e.event == 'edit') {
				this.edittaxscheme(e);
			}
			if (e.event == 'del') {
				this.deltaxscheme(e);
			}
			if (e.event == 'setcargo') {
				this.setcargo(e);
			}
		},
		//添加税率方案
		addtaxscheme(e) {
			var that = this;
			this.$apipost.get.GetLinkInfo({ l_id: e.l_id }).then(res => {
				if (res.info != undefined) {
					Utils.$emit('go', {
						l_url: '/baseinfo/cargotaxscheme',
						l_id: e.l_id,
						l_name: '新增方案',
						urlparam: { id: '', iscopy: 0, l_tablename: res.info.l_tablename }
					});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		//编辑方案
		edittaxscheme(e) {
			var that = this;
			this.$apipost.get.GetLinkInfo({ l_id: e.l_id }).then(res => {
				if (res.info != undefined) {
					Utils.$emit('go', {
						l_url: '/baseinfo/cargotaxscheme',
						l_id: e.l_id,
						l_name: '修改方案',
						urlparam: { id: that.schemelist[e.index].c_id, iscopy: 0, l_tablename: res.info.l_tablename }
					});
				} else that.$tool.message('此功能无法启用', 0);
			});
		},
		//设置商品
		setcargo(e) {
			//弹窗选择商品
			if(this.$refs.selectcargocno!=undefined){
				this.$refs.selectcargocno.init({c_id:this.schemelist[e.index].c_id,gridheight:'500px',checktrigger:true,tips:'勾选/取消勾选 即可增减商品'});
			}
		},
		deltaxscheme(e) {
			var that = this;
			this.$confirm('确定删除此方案吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			})
				.then(() => {
					this.$tool.loading('正在删除', this.divclass);
					this.$apipost.post.Deltaxscheme({c_id:that.schemelist[e.index].c_id}).then(res => {
						this.$tool.loadingclose();
						if (res.state == '1') {
							this.$tool.message('删除成功', 1);
							that.refreshgrid(true);
						} else {
							this.$tool.message(res.message, 0);
						}
					});
				})
				.catch(() => {});
		},
		ResetFilterInfo() {
			this.searchbox='';
			this.refreshgrid(true);
		}
	}
};
</script>
